import { type CbhFeatureFlag } from "../FeatureFlags";
import { type CbhFeatureFlags } from "../FeatureFlags/CbhFeatureFlags";

export const defaultAttendanceScoreFeatureFlag: CbhFeatureFlags[CbhFeatureFlag.ATTENDANCE_SCORE_INFO] =
  {
    attendanceScoreInfo: false,
    lowAttendanceScoreBanner: false,
    disableSecondShiftBonus: false,
  };

export const DEFAULT_CLOCK_IN_BONUS_POINTS = 5;

export const ON_TIME_BONUS_GRACE_PERIOD_MINUTES = 5;

export const CLIPBOARD_SCORE = "Clipboard Score";
